import { FormlyFieldConfig } from '@ngx-formly/core';

export function getOptionalFields(
        updateAgreement: Boolean,
        customFieldClass: string
    ): FormlyFieldConfig[] {
    return [
        {  
            fieldGroupClassName: 'row', 
            ...(updateAgreement)
            ?
            {            
                wrappers: ['expansion-panel'],
                props: {
                    label: 'Optional',
                    expanded: false,
                    expClass: 'exp-class'
                },
            } : {},
            fieldGroup: [
                {
                    key: 'UnitNumber.value',
                    type: 'input',
                    className: customFieldClass,
                    props: {
                        label: 'Unit Number',
                        appearance: 'outline', 
                        floatLabel: 'always',
                    },
                },
                // // {
                // //     key: 'Phone.value',
                // //     type: 'input',
                // //     className: customFieldClass,
                // //     props: {
                // //         label: 'Primary Phone',
                // //         appearance: 'outline', 
                // //         floatLabel: 'always',
                // //     },
                // // },                
                {
                    key: 'CoAppUnitNumber.value',
                    type: 'input', // Automatically creates a text input
                    className: customFieldClass,
                    props: {
                        label: 'Co-App Unit Number',
                        appearance: 'outline', 
                        floatLabel: 'always',
                    },
                },                
                // // {
                // //     key: 'CoAppHomeNumber.value',
                // //     type: 'input',
                // //     className: customFieldClass,
                // //     props: {
                // //         label: 'Co-App Home Number',
                // //         appearance: 'outline', 
                // //         floatLabel: 'always',
                // //     },
                // // },  
            ]
        }
    ]
}